/* eslint-disable no-magic-numbers */
import { projectEndpoint, projectDetailsEndpoint, dimensionEndpoint, projectDownloadEndpoint } from './endpoints.js';
import showSnackBar from './snackbar';
import logger from './util-logger';

export default {
    init: () => {
        const params = (new URL(document.location)).searchParams;
        const campaignID = params.get('id');
        const detailsEndpoint = projectDetailsEndpoint + '?id=' + campaignID;
        let filterData;

        const settings = {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
        };

        function redirectToLogin() {
            localStorage.clear();
            window.location.href = '/';
        }

        function checkSession(json){
            const err = json.errors;
            if (err){
                logger.low(err);
                for ( const [key, value] of Object.entries(err)) {
                    logger.debug('key: ' + key);
                    logger.debug('value: ' + value);
                    key == 'E011' ?  redirectToLogin() : '';
                }
            }
        }

        function sortByCreatedDate(a, b) {
            if (!a) {
                return -1;
            } else if (!b) {
                return -1;
            } else if (a.created_date < b.created_date) {
                return 1;
            } else {
                return -1;
            }
        }

        function loadCampaign (url){
            const loader = document.querySelector('.mdl-spinner.mdl-loader');
            loader.classList.add('is-active');

            const onFail = (error) => {
                logger.crit(error);
            };

            const getdata = new Promise( (resolve) => {
                fetch( dimensionEndpoint, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        filterData = json.data;
                        resolve();
                        return filterData;
                    });
            });
            getdata.then( () => {
                fetch(url, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        const data = json.data;
                        const campaigns = data.campaigns;
                        logger.debug(data);
                        checkSession(json);
                        loader.classList.remove('is-active');
                        if ( document.querySelector('.remove-hidden')) {
                            document.querySelectorAll('.remove-hidden').forEach((div) => {
                                div.removeAttribute('hidden');
                            });
                        }
                        if ( document.querySelector('.campaignList') ) {
                            addDataToTable(campaigns);
                        }
                        if ( document.querySelector('.campaignDetails') ) {
                            document.querySelector('.user-campaign-buttons').removeAttribute('hidden');
                            addCampaignDetailData(data);
                            checkIfUndefined();
                        }
                    }).catch((error) => { return onFail(error); } );
            });
        }

        function endsWithPipe(name){
            const num = -1;
            return name.endsWith('|', name.length) ? name.slice(0, num) : name;
        }

        function addDataToTable(campaigns) {
            campaigns.sort(sortByCreatedDate).map((item) => {
                return document.querySelector('#existing-campaigns tbody.campaign-list').innerHTML += `
                    <tr>
                        <td class="mdl-data-table__cell--non-numeric"><a href="/campaign?id=${item.id}">${ endsWithPipe(item.name.replace(/"/g, ''))}</a></td>
                        <td class="mdl-data-table__cell--non-numeric center-cell">${item.type}</td>
                        <td class="mdl-data-table__cell--non-numeric center-cell">${item.created_by}</td>
                        <td class="mdl-data-table__cell--non-numeric center-cell">${formatDate(item.created_date)}</td>
                        <td class="mdl-data-table__cell--non-numeric center-cell">${item.agency}</td>
                    </tr>
                `;
            });
        }

        function filterList(dimensionName, referenceName){
            const dims = filterData.dimensions;
            const refValues = dims.filter( (dim) => {
                if ( dim.type == 'Lookup'){
                    return dim.reference_values;
                }
            });
            const dimensionValues = dims.map( (dim) => {
                return dim.id  == dimensionName ? dim.name : '';
            });

            const dimensionValue = dimensionValues.join('').toString();
            const refVal = refValues.map( (refValue) => {
                for ( const [key, value] of Object.entries(refValue.reference_values)){
                    if ( key == referenceName && key ) {
                        const val = value.split(',');
                        return [...val];
                    }
                }
            });
            const ref_val = refVal.join('').toString();
            return ref_val;
        }

        function enterEditMode(btn, exitBtn){
            btn.removeAttribute('hidden');
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelectorAll('.user-project.side-by-side:not([hidden])').forEach( (project) => {
                    project.querySelector('.button-holder').removeAttribute('hidden');
                });
                document.body.classList.add('editMode');
                btn.setAttribute('hidden', '');
                exitEditMode(btn, exitBtn);
            });
        }

        function exitEditMode(btn, exitBtn) {
            exitBtn.removeAttribute('hidden');
            exitBtn.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelectorAll('.user-project.side-by-side:not([hidden])').forEach( (project) => {
                    project.querySelector('.button-holder').setAttribute('hidden', '');
                });
                btn.removeAttribute('hidden');
                document.body.classList.remove('editMode');
                exitBtn.setAttribute('hidden', '');
            });
        }

        function checkForValue(value){
            return value ? value : 'N/A';
        }

        function checkIfUndefined(){
            document.querySelectorAll('td').forEach( (td) => {
                if ( td.innerText == 'undefined' ) {
                    td.innerText = 'N/A';
                }
            });
        }

        function filterRefs(dim, ref) {
            if ( ref ) {
                return ref.length > 1 ? ref.map( (item) => { return checkForValue(filterList(dim, item)); } ) : checkForValue(filterList(dim, ref));
            }
        }

        function addCampaignDetailData(campaign){
            const campaignNameTable = document.querySelector('table.user-campaign-name');
            const campNames = campaignNameTable.querySelector('tr.campaign-name-listed');
            const names = campaign.name.split('|');

            const btn = document.querySelector('.enter-edit-mode-btn');
            const exitBtn = document.querySelector('.exit-mode-btn');

            if (campaign.editable === true) {
                enterEditMode(btn, exitBtn);
            }

            function addAdGroups(table){
                document.querySelector('.user-ad-group').removeAttribute('hidden');
                campaign.adGroups.forEach( (val) => {
                    const groups = val.dimensions;
                    const tbody = document.createElement('tbody');
                    table.appendChild(tbody);
                    table.innerHTML += `
                    <tr>
                        <td>${filterRefs('Search Type', groups['Search Type'])}</td>
                        <td>${checkForValue(groups['Search Detail'])}</td>
                        <td>${filterRefs('Language', groups.Language)}</td>
                        <td>${filterRefs('Audience', groups.Audience)}</td>
                        <td>${filterRefs('Attitudinal Segment', groups['Attitudinal Segment'])}</td>
                        <td>${checkForValue(groups['Additional Placement Information'])}</td>
                        <td class="edit"><a class="edit-campaign-btn" href="/edit-adgroup?id=${campaign.id}&adgroup=${val.id}"> <span class="material-icons">create</span></a></td>
                        <td class="edit">
                                <button class="delete-campaign-btn delete-adgroup-btn mdl-button mdl-button--raised" data-adgroup="${val.id}"><span class="material-icons">clear</span></button>
                            </td>
                    </tr>`;
                });
            }

            function addEmails(table) {
                campaign.emails.forEach( (val) => {
                    const email = val.dimensions;
                    const tbody = document.createElement('tbody');
                    table.appendChild(tbody);
                    table.innerHTML += `
                    <tr>
                        <td>${filterRefs('Channel', email.Channel)}</td>
                        <td>${filterRefs('Engagement Type', email['Engagement Type'])}</td>
                        <td>${checkForValue(email['Content Name'])}</td>
                        <td>${filterRefs('Creative Concept', email['Creative Concept'])}</td>
                        <td>${checkForValue(email['Creative Talent'])}</td>
                        <td>${filterRefs('Branded/Unbranded', email['Branded/Unbranded'])}</td>
                        <td>${filterRefs('Language', email.Language)}</td>
                        <td>${filterRefs('Agency Partner', email['Agency Partner'])}</td>
                        <td>${checkForValue(formatDate(email['Start Date']))}</td>
                        <td class="edit"><a class="edit-campaign-btn" href="/edit-email?id=${campaign.id}&email=${val.id}"> <span class="material-icons">create</span></a></td>
                        <td class="edit">
                                <button class="delete-campaign-btn delete-email-btn mdl-button mdl-button--raised" data-email="${val.id}"><span class="material-icons">clear</span></button>
                            </td>
                    </tr>`;
                });
            }

            if ( campaign.type == 'Media' ) {
                document.querySelector('.user-project.placements').removeAttribute('hidden');
                document.querySelector('.user-project.creatives').removeAttribute('hidden');
                campaign.placements.length > 0 ? addPlacementsCreatives() : '';
            }

            if ( campaign.type == 'Search' ) {
                const adgroupTable = document.querySelector('table.user-ad-group');
                document.querySelector('.user-project.ad-groups').removeAttribute('hidden');
                campaign.adGroups.length > 0 ? addAdGroups(adgroupTable) : '';
            }

            if (campaign.type == 'Email') {
                const emailNameTable = document.querySelector('table.user-email-name');
                document.querySelector('.user-project.emails').removeAttribute('hidden');
                if ( campaign.emails && campaign.emails.length > 0 ) {
                    emailNameTable.removeAttribute('hidden');
                    addEmails(emailNameTable);
                }
            }

            function addPlacementsCreatives(){
                if ( campaign.placements  && campaign.placements.length > 0 ) {
                    document.querySelector('table.placement-table').removeAttribute('hidden');
                    campaign.placements.forEach( (placement) => {
                        const dim = placement.dimensions;
                        const creatives = placement.creatives;
                        document.querySelector('table.placement-table tbody.placement-body').innerHTML += `
                        <tr>
                            <td>${filterRefs('Channel', dim.Channel)}</td>
                            <td>${filterRefs('Media Vendor', dim['Media Vendor'])}</td>
                            <td>${filterRefs('Engagement Type', dim['Engagement Type'])}</td>
                            <td>${filterRefs('Targeting Type', dim['Targeting Type'])}</td>
                            <td>${checkForValue(dim['Targeting Type Details'])}</td>
                            <td>${filterRefs('Audience', dim.Audience)}</td>
                            <td>${filterRefs('Attitudinal Segment', dim['Attitudinal Segment'])}</td>
                            <td>${filterRefs('Buy Type', dim['Buy Type'])}</td>
                            <td>${checkForValue(dim['Additional Placement Information'])}</td>
                            <td class="edit"><a class="edit-campaign-btn" href="/edit-placement?id=${campaign.id}&placementid=${placement.id}"> <span class="material-icons">create</span></a></td>
                            <td class="edit">
                                <button class="delete-campaign-btn delete-placement-btn mdl-button mdl-button--raised" data-campaign="${placement.id}"><span class="material-icons">clear</span></button>
                            </td>
                        </tr>`;

                        if ( creatives.length > 0 ) {
                            document.querySelector('.user-campaigns.creative-table').removeAttribute('hidden');
                            creatives.forEach( (c) => {
                                const creative = c.dimensions;
                                const placementsAppened = c.placement;
                                document.querySelector('table.creative-table tbody').innerHTML += `
                                <tr>
                                    <td>${checkForValue(creative['Content Name'])}</td>
                                    <td>${filterRefs('Creative Concept', creative['Creative Concept'])}</td>
                                    <td>${checkForValue(creative['Creative Talent'])}</td>
                                    <td>${filterRefs('Branded/Unbranded', creative['Branded/Unbranded'])}</td>
                                    <td>${filterRefs('Media Content Type', creative['Media Content Type'])}</td>
                                    <td>${filterRefs('Asset Format', creative['Asset Format'])}</td>
                                    <td>${checkForValue(creative['Video Duration'])}</td>
                                    <td>${checkForValue(creative['Call to Action'])}</td>
                                    <td>${filterRefs('Agency Partner', creative['Agency Partner'])}</td>
                                    <td>${filterRefs('Language', creative.Language)}</td>
                                    <td>${filterRefs('Creative Dynamically Served', creative['Creative Dynamically Served'])}</td>
                                    <td>${checkForValue(creative['Additional Creative Information'])}</td>
                                    <td>${checkForValue(placementsAppened)}</td>
                                    <td class="edit"><a class="edit-campaign-btn" href="/edit-creative?id=${campaign.id}&placementid=${placement.id}&creativeid=${c.id}"> <span class="material-icons">create</span></a></td>
                                    <td class="edit">
                                    <button class="delete-campaign-btn delete-creative-btn mdl-button mdl-button--raised" data-creative="${c.id}"><span class="material-icons">clear</span></button>
                                    </td>
                                </tr>`;
                            });
                        }
                    });
                }
            }

            if ( campaign.name  && campaign.name.length > 0) {
                document.querySelector('.user-campaigns.user-campaign-name').removeAttribute('hidden');
                campNames.innerHTML = ` 
                <td>${checkForValue(names[0])}</td>
                <td>${checkForValue(names[1])}</td>
                <td>${checkForValue(names[2].replace(/"/g, ''))}</td>
                <td>${checkForValue(names[3])}</td>
                <td>${checkForValue(names[4])}</td>
                <td>${checkForValue(names[5])}</td>
                <td>${checkForValue(names[6])}</td>
                <td class="edit"><a class="edit-campaign-btn" href="/edit-campaign?id=${campaign.id}"> <span class="material-icons">create</span></a></td>
                <td class="edit">
                <button id="delete-campaign" class="delete-campaign-btn mdl-button mdl-button--raised" data-campaign="${campaign.id}"><span class="material-icons">clear</span></button>
                </td>`;
            }

            if ( campaign.tags &&  campaign.tags.length > 0 ) {
                addCampaignTags(campaign);
                const exportBtn = document.querySelector('.export-button');
                exportBtn.setAttribute('href', projectDownloadEndpoint + '?campaignId=' + campaignID);
            } else {
                const exportBtn = document.querySelector('.export-button');
                exportBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    showSnackBar.showMessage('Sorry, no tags exist!');
                });
            }
        }

        function addCampaignTags(campaign){
            document.querySelector('.user-campaigns.utm-url').removeAttribute('hidden');
            const urlTable = document.querySelector('table.utm-url');
            const utmTable = document.querySelector('table.user-campaigns.user-utms-content');
            utmTable.removeAttribute('hidden');
            campaign.tags.forEach( (val) => {
                const tag = val.FINAL_URL;
                urlTable.querySelector('tbody').innerHTML += `
                    <tr>
                        <td>${checkForValue(tag)}</td>
                    </tr>
                `;
                utmTable.querySelector('tbody').innerHTML += `
                <tr>
                    <td>${checkForValue(val.UTM_SOURCE)}</td>
                    <td>${checkForValue(val.UTM_MEDIUM)}</td>
                    <td>${checkForValue(val.UTM_CAMPAIGN)}</td>
                    <td>${checkForValue(val.UTM_CONTENT)}</td>
                </tr>
            `;
            });
        }

        function formatDate(date) {
            const inputDate = new Date(date);
            return inputDate.toLocaleDateString('en-US', { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' });
        }

        function editCampaignBtns(){
            const addPlacementBtn = document.querySelector('.add-placements-button');
            const addCreativeBtn = document.querySelector('.add-creatives-button');
            const addAdGroupBtn = document.querySelector('.add-adgroups-button');
            const addEmailBtn = document.querySelector('.add-emails-button');
            const exportBtn = document.querySelector('.export-button');
            const params = (new URL(document.location)).searchParams;
            const id = params.get('id');
            addPlacementBtn.setAttribute('href', '/add-placements?id=' + id);
            addCreativeBtn.setAttribute('href', '/add-creatives?id=' + id);
            addAdGroupBtn.setAttribute('href', '/add-adgroups?id=' + id);
            addEmailBtn.setAttribute('href', '/add-email?id=' + id);
        }

        if ( document.querySelector('.campaignList') ){
            loadCampaign(projectEndpoint);
        }
        if ( document.querySelector('.campaignDetails') ) {
            editCampaignBtns();
            loadCampaign(detailsEndpoint);
        }
    }
};
